import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-5 rounded-full bg-primary-500"></div>
              <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">
                精选推荐
              </span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              编辑精选深度好文
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              精挑细选的优质解析文章，帮您快速抓住鬼父2的核心要点
            </p>
          </div>
          <Link
            to="/category/plot"
            className="flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {featured.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="w-full sm:w-[240px] h-[200px] sm:h-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-5 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-accent-100 text-accent-800">
                        {article.category === 'plot' ? '剧情解析' :
                         article.category === 'characters' ? '人物介绍' :
                         article.category === 'classic-scenes' ? '经典场景' :
                         article.category === 'themes' ? '主题分析' : '续集看点'}
                      </span>
                      {article.hot && (
                        <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-primary-100 text-primary-700">
                          热门
                        </span>
                      )}
                    </div>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i> {article.publishDate}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i> {article.readTime}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}